import TrainingCard from './TrainingCard.vue';

export { TrainingCard };



// WEBPACK FOOTER //
// ./src/modules/home/trainingCard/index.js